module.exports = __webpack_public_path__ + "img/food_18.05c7b82c.jpg";